module.exports = __webpack_public_path__ + "static/media/cpm-design-thinking-opener-1024x731.90ebd8ec.jpg";